import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductFeatures } from './components/ProductFeatures';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream-50 font-sans text-brand-navy-700" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <ProductFeatures data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TrustSection data-id="element-7" />
        <FAQ data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}